import React from 'react'
import {
    Card,
    TypographyContent,
    ContentDanger,
    Content,
    OverSection,
    TypographyTitle,
} from './styles'
import { IVacancy } from 'src/types/contenfull'
import { useI18nInstance } from 'src/provider/LocaleProvider'

export const MapWereHiring = ({ fields, sys }: IVacancy) => {
    const i18n = useI18nInstance()

    return (
        <Card to={`/wereHiring/${sys?.id}`}>
            <OverSection margin={'xlarge'}>
                {fields && fields.inportant && (
                    <ContentDanger
                        marginTop={['xxsmall', 'xxsmall', 'xsmall', 'xxsmall']}
                    >
                        <TypographyContent
                            variant={'h2'}
                            fontSize={[
                                'xxxsmall',
                                'xxxsmall',
                                'xxsmall',
                                'xxxsmall',
                            ]}
                            fontWeight={500}
                        >
                            {i18n.language === 'es' ? (
                                <>{fields.inportantSpanish}</>
                            ) : (
                                <>{fields.inportant}</>
                            )}
                        </TypographyContent>
                    </ContentDanger>
                )}
                <Content
                    marginTop={['medium', 'medium', 'xxsmall', 'xxmedium']}
                >
                    <TypographyTitle
                        variant={'h2'}
                        fontSize={['large', 'large', 'medium', 'xxxlarge']}
                        fontWeight={700}
                    >
                        {fields?.officio}
                    </TypographyTitle>
                </Content>
                <Content
                    marginTop={['xxxsmall', 'xxxsmall', 'xxsmall', 'xxmedium']}
                >
                    <TypographyTitle
                        variant={'h2'}
                        fontSize={[
                            'xxxsmall',
                            'xxxsmall',
                            'xxsmall',
                            'xxxmedium',
                        ]}
                        fontWeight={500}
                    >
                        {i18n.language === 'es' ? (
                            <>{fields?.localicaionSpanish}</>
                        ) : (
                            <>{fields?.localicaion}</>
                        )}
                    </TypographyTitle>
                </Content>
            </OverSection>
        </Card>
    )
}
